import api from "./api";

export async function getRoadmap() {
  const { data } = await api.get("/api/roadmap");
  return data;
}

export async function regenerateRoadmap() {
  const { data } = await api.post("/api/roadmap/regenerate");
  return data;
}
